import { render, staticRenderFns } from "./app-setting.vue?vue&type=template&id=eb119832&"
import script from "./app-setting.vue?vue&type=script&lang=ts&"
export * from "./app-setting.vue?vue&type=script&lang=ts&"
import style0 from "./app-setting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports